import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=4846f69f&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=4846f69f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846f69f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4846f69f')) {
      api.createRecord('4846f69f', component.options)
    } else {
      api.reload('4846f69f', component.options)
    }
    module.hot.accept("./MainView.vue?vue&type=template&id=4846f69f&scoped=true", function () {
      api.rerender('4846f69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/MainView.vue"
export default component.exports